import { Component, ComponentRef, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AppServices } from 'src/app/_services/app.service';
import { StorageService } from 'src/app/_services/storage.service';
import { DynamicModalComponentService } from 'src/app/common/services/dyamic-modal-component.service';
import { MODALCOMPONENT } from 'src/app/common/modal/modal.constants';
import { AlertModalComponent } from 'src/app/common/modal/alert-modal/alert-modal.component';
import { CreateCampaignSuccessComponent } from '../create-campaign-success/create-campaign-success.component';

@Component({
  selector: "app-upload-creatives",
  templateUrl: "./upload-creatives.component.html",
  styleUrls: ["./upload-creatives.component.less"],
  encapsulation: ViewEncapsulation.None,
})
export class UploadCreativesComponent {
  fileAccept: string = ".jpg,.jpeg,.png";
  fileType: string = "image";
  infoMsg: string = "You can also upload multiple versions of the same Ad to analyze and compare.";
  errorMsg: string = "";
  file: any = null;
  brands: any = [];
  selectedChannels: any = [];
  actionType: string = '';
  isAnalyze: boolean = false;
  isDisplayAd: boolean = true;
  isVideoAd: boolean = true;
  displayAdLimit: number = 0;
  videoAdLimit: number = 0;
  user_trial: string = ""
  user: any;
  breadcrumb: any = [
    {
      name: "Creatives",
      link: "/creatives/pre-flight/list",
    },
    {
      name: "Upload Ads",
      link: null,
    },
  ];
  categories: string[] = [];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dynamicModalService: DynamicModalComponentService,
    private storage: StorageService,
    private service: AppServices,
    private modal: NzModalService,
    private route: Router
  ) { }

  uploadCreativeForm = new FormGroup({
    creativeName: new FormControl('', [Validators.required, Validators.maxLength(75)]),
    creativeType: new FormControl('image', [Validators.required]),
    brandName: new FormControl(''),
    channel: new FormControl([]),
    category: new FormControl("", [Validators.required]),
    industry: new FormControl({ value: "", disabled: true }),
  });

  get f(): { [key: string]: AbstractControl } {
    return this.uploadCreativeForm.controls;
  }

  ngOnInit() {
    setTimeout(() => {
      this.user = this.storage.getUser();
      let user = this.user;
      this.brands = user.brands;
      let client = user.client;
      this.user_trial = client.status;
      this.isAnalyze = user.permission.isAnalyze;
      this.categories = user.client?.categories ?? [];
      this.uploadCreativeForm.patchValue({ industry: client?.industry });
      if (this.user_trial === 'trial') {
        user.permission.isUpload = true;
        user.permission.isAnalyze = true;
        user.permission.preFlight = true;
        this.uploadCreativeForm.get('brandName')?.clearValidators();
      } else {
        this.uploadCreativeForm.get('brandName')?.setValidators([Validators.required]);
      }
      this.uploadCreativeForm.get('brandName')?.updateValueAndValidity();

      if (client) {
        this.isDisplayAd = client.featureAccess.imageAd.isAvailable;
        this.isVideoAd = client.featureAccess.videoAd.isAvailable;
        this.displayAdLimit = client.featureAccess.imageAd.adLimit;
        this.videoAdLimit = client.featureAccess.videoAd.adLimit;
      }

      if (this.isDisplayAd) {
        this.fileAccept = ".jpg,.jpeg,.png";
        this.fileType = "image";
      } else {
        this.fileAccept = ".mp4,.avi,.wmv,.ogg,.webm,.mov";
        this.fileType = "video";
      }
    }, 10);
  }


  creativeTypeChange(evt: any): void {
    if (evt === 'video') {
      this.fileAccept = ".mp4,.avi,.wmv,.ogg,.webm,.mov";
      this.fileType = "video";
    } else {
      this.fileAccept = ".jpg,.jpeg,.png";
      this.fileType = "image";
    }
  }

  cancel = () => {
    this.route.navigate(["creatives", "pre-flight", "list"]);
  };

  closeModal = () => {};

  getFormData(analyze: string): any {
    let input = this.uploadCreativeForm.value;
    let formData = new FormData();
    formData.append('artifactType', this.fileType);
    formData.append('brand', input.brandName ? input.brandName : '');
    formData.append('channel', this.selectedChannels?.join(", "));
    // this.selectedChannels.forEach((channel: any, index:any) => {
    //   formData.append(`channel[${index}]`, channel);
    // });
    formData.append('multipartFile', this.file);
    formData.append('analyze', analyze);
    formData.append('title', input.creativeName ? input.creativeName : '');
    formData.append('groupName', '');
    formData.append("phase", "pre-flight");
    formData.append("industry", input.industry ?? this.user?.client?.industry);
    formData.append("category", input.category ?? "");
    return formData;
  }

  upload = () => {
    this.errorMsg = "";
    if (this.uploadCreativeForm.status.toLowerCase() === 'invalid' || !this.file) {
      this.errorMsg = "All fields are mandatory. Please check and try again";
      window.scrollTo(0, 0);
      return;
    }
    if(this.selectedChannels && this.selectedChannels.length == 0){
      this.errorMsg = "Uh! Oh! Seems like you forgot you too choose channel(s) for the Creative.";
      window.scrollTo(0, 0);
      return;
    }
    this.actionType = "upload";
    let formData = this.getFormData("false");
    this.createAd(formData);
  };

  uploadAnalyze = () => {
    this.errorMsg = "";
    if (this.uploadCreativeForm.status.toLowerCase() === 'invalid' || !this.file) {
      this.errorMsg = "All fields are mandatory. Please check and try again";
      window.scrollTo(0, 0);
      return;
    }
    if(this.selectedChannels && this.selectedChannels.length == 0 && this.user_trial!="trial"){
      this.errorMsg = "Uh! Oh! Seems like you forgot you too choose channel(s) for the Creative.";
      window.scrollTo(0, 0);
      return;
    }
    this.actionType = "analyze";
    let formData = this.getFormData("true");
    this.createAd(formData);
  };

  createAd(formData: any): void {
    // console.log(formData)
    this.service.createAd(formData).subscribe({
      next: (data: any) => {
        if (data.status.toLowerCase() === 'success') {
          let content = "Creative uploaded successfully";
          if (this.actionType === 'analyze') {
            content = "We are analyzing the creative now. Check back in few minutes for the report.";
          }
          this.modal.success({
            nzTitle: "Success",
            nzContent: content,
            nzClassName: "small-modal",
            nzClosable: false,
            nzMaskClosable: false,
            nzKeyboard: false,
            nzOnOk: () => {
              this.route.navigate(["creatives", "pre-flight", "list"]);
            },
          });
          // this.dynamicModalService.createComponentModal('', CreateCampaignSuccessComponent, this.viewContainerRef,'', 'successModal');
          // this.dynamicModalService.updateModalCotentComponent(MODALCOMPONENT.CREATE_CAMPAIGN_SUCCESS);
        } else {
          this.errorMsg = "Unable to upload creative, please try again later";
          window.scrollTo(0, 0);
        }
      },
      error: err => {
        if (err.error && err.error.errorCode === "QUOTA_EXCEEDED") {
          if (this.fileType === "image") {
            this.errorMsg = `You can analyze upto ${this.displayAdLimit} display Ads only.`
          } else {
            this.errorMsg = `You can analyze upto ${this.videoAdLimit} video Ads only.`;
          }
        } else {
          this.errorMsg = "Unable to upload creative, please try again later";
        }
        window.scrollTo(0, 0);
      }
    })

  }

  onChannelChange = (selectedValues: string[]) => {

    this.selectedChannels = selectedValues
    console.log(this.selectedChannels)

  }


  getFile = (file: any) => {
    this.file = file;
  };
}
